/* istanbul ignore file */
import styled from 'styled-components';
import ArrowIcon from '@catalogo/theme-svg/arrow.svg';

const Container = styled.div<{ margin?: string }>`
  border: 1px solid #dfdfdf;
  position: relative;
  background: #fafafa;
  border-radius: 8px;
`;

const ContentWrapper = styled.div`
  background: #fff;
  overflow: hidden;
  transition: max-height 0.5s 0s ease-in-out;
  border-radius: 8px;
`;

const Content = styled.div`
  padding: 0 0 12px 0;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 8px;
  margin: 0px 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 160%;
  color: #282828;
  place-content: space-between;
  cursor: pointer;
  text-transform: ${({ theme }) => theme.titleTransform};
`;

const TitleUI = styled.p<{ $isVisible: boolean | undefined }>`
  font-size: 14px;
  line-height: 160%;
  font-weight: ${({ $isVisible }) => ($isVisible ? '700' : '400')};
  color: ${({ $isVisible }) => ($isVisible ? '#282828' : '#6F6F6F')};
`;

const WrapperTitle = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ArrowIconUI = styled(ArrowIcon)<{ $isVisible: boolean | undefined }>`
  fill: ${({ $isVisible, theme }) => ($isVisible ? theme.primaryColor : '#000000')};
  width: 12px;
  height: 12px;
  display: flex;
  flex-direction: column;
  align-self: center;
  ${({ $isVisible }) => $isVisible && `transform: rotate(180deg);`}
  transition: transform 500ms;
`;

export { TitleContainer, TitleUI, ArrowIconUI, Container, Content, ContentWrapper, WrapperTitle };
